module.exports = __webpack_public_path__ + "img/2018.eed78b65.png";